import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { Channel } from '../../models/channel.model';
import * as channelActions from '../actions/channel.actions';

export interface ChannelState {
  channel: Channel | null;
  status?: string | null;
  loading: boolean;
}

export const initialState: ChannelState = {
  channel: null,
  status: undefined,
  loading: false,
};

export const getUserState = createFeatureSelector<ChannelState>('channel');
export const channel = (state: ChannelState) => state.channel;
export const loading = (state: ChannelState) => state.loading;

export const channelReducer = createReducer(
  initialState,
  on(channelActions.loadChannel, (state) => ({ ...state, loading: true })),
  on(channelActions.loadChannelSuccess, (state, { channel }) => ({
    channel: channel,
    loading: false,
  })),
  on(channelActions.verifyChannelName, (state) => ({
    ...state,
    loading: true,
  })),
  on(channelActions.verifyChannelNameSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(channelActions.verifyChannelNameFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(channelActions.createChannel, (state) => ({ ...state, loading: true })),
  on(channelActions.createChannelSuccess, (state, { channel }) => ({
    ...state,
    channel: channel,
    loading: false,
  })),
  on(channelActions.createChannelFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(channelActions.updateChannel, (state) => ({ ...state, loading: true })),
  on(channelActions.updateChannelImage, (state) => ({
    ...state,
    loading: true,
  })),
  on(channelActions.updateChannelSuccess, (state, { channel }) => ({
    ...state,
    channel: channel,
    loading: false,
  })),
  on(channelActions.updateChannelFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(channelActions.updateStatus, (state, { status }) => ({
    ...state,
    status: status,
  })),
  on(channelActions.clear, (state) => initialState)
);
